import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Phone, Leaf, Heart, ShieldCheck } from 'lucide-react';
export function HoneyPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-404" data-mp="2krbb10rjn2rj">
      <Header data-id="element-405" data-mp="2gqrbjqjhzn28" />

      {/* Hero Section with Forest Background */}
      <section className="relative pt-32 pb-24 overflow-hidden" style={{
      backgroundImage: 'linear-gradient(rgba(13, 18, 29, 0.55), rgba(13, 18, 29, 0.75)), url(https://cdn.magicpatterns.com/uploads/eLgKy3Qav9dc5TFrGCULbj/image_%2822%29.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-406" data-mp="1szdjllp9dths">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-407" data-mp="3depap6mmmcfc">
          <a href="/saint-lucia" className="inline-flex items-center text-white/90 hover:text-white transition-colors mb-12 drop-shadow" data-id="element-408" data-mp="38gw3qbdi1ee0">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-409" data-mp="1bq08omi75din" />
            Back to Saint Lucia
          </a>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[60vh]" data-id="element-410" data-mp="1frbz2u8wa2rw">
            {/* Text content */}
            <div className="text-center lg:text-left" data-id="element-411" data-mp="1pn6p4afg704p">
              <div className="inline-block px-4 py-1.5 rounded-full bg-amber-400/20 backdrop-blur-sm border border-amber-300/40 text-amber-200 text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-412" data-mp="1pmnhbmjihs4e">
                <span className="inline-flex items-center gap-2" data-id="element-413" data-mp="wzay9mck82fu">
                  <Leaf className="w-4 h-4" data-id="element-414" data-mp="11xkorjncaev4" />
                  100% Natural • From Saint Lucia
                </span>
              </div>

              <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight drop-shadow-2xl" data-id="element-415" data-mp="16pvrsvddmgrw">
                Pure Honey,
                <br data-id="element-416" data-mp="e7i2jk63w34f" />
                <span className="text-amber-300" data-id="element-417" data-mp="e6ytyu2cir32">Pure Nature.</span>
              </h1>

              <p className="text-xl text-white/95 mb-8 leading-relaxed drop-shadow-lg max-w-xl" data-id="element-418" data-mp="66isro4nn63d">
                Authentic, real natural pure honey — untouched by additives or
                processing — harvested from the pristine tropical landscapes of
                Saint Lucia.
              </p>

              <a href="tel:+13475836724" className="inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold rounded-full text-slate-900 bg-amber-300 hover:bg-amber-200 transition-colors shadow-2xl shadow-amber-500/30" data-id="element-419" data-mp="azbxwd41cgfz">
                <Phone className="w-5 h-5" data-id="element-420" data-mp="3tcjtoo8k0anr" />
                Order: 1 (347) 583-6724
              </a>
            </div>

            {/* Honey Label */}
            <div className="relative flex justify-center lg:justify-end" data-id="element-421" data-mp="3of9wuniu4wpw">
              <div className="absolute -inset-8 bg-amber-400/30 blur-3xl rounded-full" data-id="element-422" data-mp="18khnx8k4745v" />
              <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-423" data-mp="13m6e2xttktnn">
                <img src="https://cdn.magicpatterns.com/uploads/rv6LLeJAANne3QdotvL8KB/Honey_Label-01.png" alt="Nature's Worker Bees Produce - Natural Honey from St. Lucia" className="max-w-full w-full lg:max-w-xl h-auto rounded-2xl shadow-2xl ring-4 ring-amber-200/30" data-id="element-424" data-mp="2lj1fu3xs4621" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 relative" data-id="element-425" data-mp="399xd3gl07tgo">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-426" data-mp="398vtuotu40nv">
          <div className="bg-white/5 backdrop-blur rounded-3xl border border-amber-500/20 p-10 md:p-14" data-id="element-427" data-mp="2vjagbtyt0dn8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-428" data-mp="30h27glrmjvqd">
              From Our Hives to Your Home
            </h2>

            <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-429" data-mp="3o5d051n62p3k">
              <p data-id="element-430" data-mp="3szpn3lnuqik2">
                <span className="text-amber-300 font-semibold" data-id="element-431" data-mp="3t094n19lb4xk">
                  TwiceBourne Holdings Ltd
                </span>{' '}
                proudly brings the pure essence of nature to homes across the
                United States, with a special focus on supporting the wellness
                of our elderly community.
              </p>

              <p data-id="element-432" data-mp="1qdc8r9vfk2nx">
                We supply authentic, real natural pure honey — untouched by
                additives or processing — harvested from the pristine tropical
                landscapes of Saint Lucia. This exceptional honey is sourced
                through our close collaboration with{' '}
                <span className="text-amber-300 font-semibold" data-id="element-433" data-mp="2e9hnpnjqg4j9">
                  Nature's Worker Bees Produce
                </span>{' '}
                of Saint Lucia, West Indies, ensuring the highest standards of
                quality and natural goodness.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Props */}
      <section className="pb-20" data-id="element-434" data-mp="39bi7yf7y2ule">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-435" data-mp="39cjupgybp5iy">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-436" data-mp="3ea3banihtue2">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 text-center" data-id="element-437" data-mp="3ecfpqqp1lmmd">
              <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-438" data-mp="3jbsifs2lhnwv">
                <Leaf className="w-7 h-7 text-amber-300" data-id="element-439" data-mp="3sadxhd8uyksw" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-440" data-mp="3s89wb32cfzwb">
                100% Natural
              </h3>
              <p className="text-slate-400" data-id="element-441" data-mp="5urwhktlfpcb">
                No additives, no processing — just pure honey straight from the
                tropics.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 text-center" data-id="element-442" data-mp="avfl5zucnu3d">
              <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-443" data-mp="juauhksoxkaw">
                <ShieldCheck className="w-7 h-7 text-amber-300" data-id="element-444" data-mp="2fwxm5ttxj489" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-445" data-mp="2bw42xdrfmdlp">
                Trusted Source
              </h3>
              <p className="text-slate-400" data-id="element-446" data-mp="2pnikrh9ls8r6">
                Sourced from Nature's Worker Bees Produce in Saint Lucia, West
                Indies.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 text-center" data-id="element-447" data-mp="2zl6i8eylfud1">
              <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-448" data-mp="2umv7m20h5ftr">
                <Heart className="w-7 h-7 text-amber-300" data-id="element-449" data-mp="38l1xovz6mbiv" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-450" data-mp="33mibqvkl8zqi">
                Wellness Focused
              </h3>
              <p className="text-slate-400" data-id="element-451" data-mp="1e94z8j2bo5eb">
                Special focus on supporting the wellness of our elderly
                community.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="pb-24" data-id="element-452" data-mp="3kyouo5g3zd21">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-453" data-mp="3pvyv0g51d94n">
          <div className="bg-gradient-to-br from-amber-500/20 via-amber-600/10 to-slate-900/40 backdrop-blur rounded-3xl border border-amber-400/30 p-12 text-center" data-id="element-454" data-mp="3px9u42njdspf">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-455" data-mp="3g42ukyfh96x9">
              Order Your Honey Today
            </h2>
            <p className="text-lg text-slate-300 mb-8" data-id="element-456" data-mp="3287ef0cgq9xk">
              To place your order or make inquiries, contact us today.
            </p>
            <a href="tel:+13475836724" className="inline-flex items-center justify-center gap-3 px-10 py-5 text-xl font-bold rounded-full text-slate-900 bg-amber-300 hover:bg-amber-200 transition-colors shadow-2xl shadow-amber-500/30" data-id="element-457" data-mp="2t5y3489decj4">
              <Phone className="w-6 h-6" data-id="element-458" data-mp="vf52r7ub2aj8" />1 (347) 583-6724
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-459" data-mp="3fbpag2n9793z" />
    </div>;
}